export default __webpack_public_path__ + "static/pt-6a3593e6796f265a7c28cbad7d3d1ae2.svg";